import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';

export const TwoColumnsInputContainer = memo(({ children, style }) => {
  const { styles } = useStyle();
  return <View style={[styles.container, style]}>{children}</View>;
});

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    flexDirection: 'row',
  },
}));
